// Downscale + re-encode an uploaded photo client-side (EXIF-corrected via
// createImageBitmap orientation), matching the Rails-side input budget so the
// wire never carries more than the server accepts. Falls back to the raw file
// when the bitmap/canvas path is unavailable rather than failing the upload.
export async function normalizePhoto(file: File, maxDimension = 1248) {
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" })
    const scale = Math.min(1, maxDimension / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement("canvas")
    canvas.width = Math.max(1, Math.round(bitmap.width * scale))
    canvas.height = Math.max(1, Math.round(bitmap.height * scale))
    canvas.getContext("2d")!.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    bitmap.close()
    const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob((result) => result ? resolve(result) : reject(), "image/jpeg", .88))
    return new File([blob], `${file.name.replace(/\.[^.]+$/, "") || "photo"}.jpg`, { type: "image/jpeg" })
  } catch (_error) {
    return file
  }
}
